import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center text-center">
          {/* Muncie Store Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Next Level Games Muncie</h3>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-start space-x-3 justify-center">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <p>Muncie, Indiana</p>
              </div>
              <div className="flex items-center space-x-3 justify-center">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <p>(765) 744-6800</p>
              </div>
              <div className="flex items-center space-x-3 justify-center">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <p>Nextlevelgames1@outlook.com</p>
              </div>
              <div className="flex items-start space-x-3 justify-center">
                <Clock className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <div>
                  <p>Mon: 12pm-8pm</p>
                  <p>Tue-Thu: 12pm-10pm</p>
                  <p>Fri-Sat: 12pm-12am</p>
                  <p>Sun: 12pm-10pm</p>
                </div>
              </div>
            </div>
          </div>

          {/* Carmel Store Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Next Level Games Carmel</h3>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-start space-x-3 justify-center">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <p>14560 River Rd Ste 130, Carmel, IN 46033</p>
              </div>
              <div className="flex items-center space-x-3 justify-center">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <p>(765) 717-0697</p>
              </div>
              <div className="flex items-center space-x-3 justify-center">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <p>Nextlevelgamescarmel@outlook.com</p>
              </div>
              <div className="flex items-start space-x-3 justify-center">
                <Clock className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <div>
                  <p>Mon: 12pm-8pm</p>
                  <p>Tue-Thu: 12pm-10pm</p>
                  <p>Fri-Sat: 12pm-12am</p>
                  <p>Sun: 12pm-10pm</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/shop/pokemon" className="hover:text-primary-400 transition-colors">
                  Pokemon Cards
                </Link>
              </li>
              <li>
                <Link to="/shop/magic" className="hover:text-primary-400 transition-colors">
                  Magic: The Gathering
                </Link>
              </li>
              <li>
                <Link to="/events" className="hover:text-primary-400 transition-colors">
                  Upcoming Events
                </Link>
              </li>
            </ul>
          </div>


          {/* Newsletter - hidden until ready
          <div>
            <h3 className="text-lg font-semibold mb-4">Stay Connected</h3>
            <p className="text-gray-400 mb-4">
              Subscribe to get exclusive deals and event updates!
            </p>
            <form className="space-y-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-4 py-2 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-primary-500"
              />
              <button
                type="submit"
                className="w-full px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg transition-colors"
              >
                Subscribe
              </button>
            </form>

            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div> */}
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex justify-center items-center">
            <p className="text-gray-400 text-sm">
              © 2026 Next Level Games. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
